import { generateShareLensURL } from "./urlUtils";
export function topLensToVideoMetadata(topLens) {
    return {
        name: topLens.lensName,
        description: topLens.lensName,
        thumbnailUrl: topLens.lensPreviewImageUrl,
        uploadDateMs: "0",
        viewCount: "",
        contentUrl: generateShareLensURL(topLens.scannableUuid),
        durationMs: "0",
        width: 0,
        height: 0,
        keywords: topLens.lensCreatorSearchTags,
        shareCount: "",
    };
}
